module.exports = __webpack_public_path__ + "static/media/lock_black_24dp.f302c288.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lock_black_24dp.svg
// module id = 248
// module chunks = 0